<template>
    <div
        class="
            productOfCardMain
        "
    >
        <div class="content">
            <img
                class="productImg"
                :src="getImgUrl(productImg)"
            />
            <div style="flex-grow:1;overflow:hidden;">
                <div
                    style="
                        font-weight: 800;
                        white-space: nowrap;
                        overflow-x: auto;
                    "
                >
                    {{ productName }}
                </div>
                <div
                    style="
                        white-space: nowrap;
                        overflow-x: auto;
                    "
                >
                    {{ specificationName }}
                </div>
                <div class="productPrice">
                    ￥{{ productPrice.toFixed(1) }}
                </div>
            </div>
        </div>

        <div class="stepper" ref="addToCartView">
            <ProductIncAndDesc :maxBuyNum="checkMaxBuyNum(shopId, productId, specificationId)" :maxNumber="stock" v-model="productNumberData"  @dataChange="updateCart" />
        </div>

        <BaseParabolaAnimate ref="addToCartAnimate" :imgPic="getImgUrl(productImg)"/>
    </div>
</template>

<script>

//
import { mapState, mapGetters, } from 'vuex'

//
import ProductIncAndDesc from "@/components/shop/ProductIncAndDesc.vue";

//
import vuex from "vuex";

export default {
    vuex,

    name: 'ProductOfCart',

    props: {
        shopId: {
            type: Number,
            required: true,
        },

        productImg: {
            type: String,
            required: true,
        },

        productName: {
            type: String,
            required: true,
        },

        productId: {
            type: Number,
            required: true,
        },

        productPrice: {
            type: Number,
            required: true,
        },

        productNumber: {
            type: Number,
            required: true,
        },

        specificationName: {
            type: String,
            required: true,
        },

        specificationId: {
            type: Number,
            required: true,
        },

        stock: {
            type: Number,
            default: 99999999,
        },
        
        shelfId: {
            default: () => {
                return [];
            },
        },
    },

    components: {
        ProductIncAndDesc,
    },

    data() {
        return {
            productNumberData: this.productNumber,
        }
    },

    computed: {
        ...mapState({
            cartInfoAll: (state) => state.cart.cartInfoAll,
        }),

        ...mapGetters('cart', [
            'getCartInfo',
        ]),

        cartInfo() {
            if(this.cartInfoAll && process.env.NODE_ENV == 'development')
            {
                console.log('productOfCart, cartInfoAll changed')
            }

            //
            return this.getCartInfo(this.shopId);
        },
    },

    methods: {
        updateCart(value) {
            //
            if(value > 0)
            {
                this.$refs.addToCartAnimate.addToCartAnimate(this.$refs.addToCartView, document.getElementById("componentCartIcon"));
            }

            //
            this.cartApiAddToCart(
                this.shopId, 
                this.specificationId, 
                value, 
                this.productId, 
                "",
            );
        },
    }
}
</script>

<style lang="scss" scoped>

.productOfCardMain
{
    display: flex;
    box-sizing: border-box;
    padding: $padding;
    align-items: center;
    font-size: $fontSizeContent;
    line-height: 2em;
}

//
.content {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
}

.productImg
{
    width: 6em; 
    height: 6em; 
    margin-right: $margin;
    flex-shrink: 0;
    border-radius: $borderRadius;
}

.productPrice
{
    color: #ff4824;
}

//
.stepper {
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
    width: 6em;
}

</style>